import { Link } from 'react-router-dom';

import { BRAND_NAME, LEGAL_URLS, NEW_TAB } from '../lib/brand.js';

/**
 * Privacy - **the website is the master** (D-15, ruled 22 September 2026).
 *
 * Written into the portal at D-14 Item 8.3 and retired here for the reason the
 * Terms were: one copy, maintained where the legal copy lives. The route stays
 * because the sign-up line points at it and because an old bookmark should land
 * somewhere useful.
 *
 * **Ruling 9 still rests on what that page says.** With no consent checkbox,
 * the basis for product and pricing updates has to be readable by somebody who
 * has no account yet - which is why the sign-up line links to the website page
 * directly rather than here.
 */
export function PrivacyPage(): React.JSX.Element {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12">
      <Link to="/" className="text-sm text-fg-muted underline">
        Back to {BRAND_NAME}
      </Link>

      <h1 className="mt-4 text-2xl font-semibold tracking-tight text-fg">Privacy</h1>

      <p className="mt-6 text-sm text-fg-2">
        Our Privacy policy lives on the {BRAND_NAME} website, so there is one copy of it and it
        is always the current one.
      </p>

      <p className="mt-4 text-sm">
        <a {...NEW_TAB} href={LEGAL_URLS.privacy} className="font-medium text-fg underline">
          Read the Privacy policy
        </a>
      </p>

      <p className="mt-6 text-sm text-fg-2">
        The{' '}
        <a {...NEW_TAB} href={LEGAL_URLS.terms} className="underline">
          Terms
        </a>{' '}
        and the{' '}
        <a {...NEW_TAB} href={LEGAL_URLS.refunds} className="underline">
          Refunds policy
        </a>{' '}
        are there too.
      </p>
    </div>
  );
}
